import React from "react";

export const University = ({width, height}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 80 80"
            fill="none"
        >
            <rect width="79.965" height="80" rx="8" fill="#0171E0" />
            <path
                d="M52.805 26.7969H42.4909L42.2473 27.975C42.6534 28.1916 43.1406 28.388 43.7091 28.564C44.2776 28.7401 44.8326 28.8822 45.374 28.9906L41.8203 45.6533C41.5491 47.0056 41.502 48.2695 41.6788 49.4449C41.8683 50.7042 42.315 51.7875 43.0188 52.6948C43.7227 53.6021 44.6905 54.313 45.9222 54.8276C47.1539 55.3421 48.6631 55.5994 50.4498 55.5994C53.4547 55.5994 55.9114 54.8276 57.8199 53.2838C59.7284 51.7401 61.0616 49.1944 61.8196 45.6465L65.2711 29.3562C65.8667 29.2208 66.4758 29.0312 67.0984 28.7875C67.7211 28.5437 68.2625 28.2729 68.7227 27.975L69.0069 26.7969H60.3172L60.0735 27.975C60.8315 28.4895 61.8061 28.95 62.9972 29.3562L59.4862 45.844C58.9375 48.3287 58.0302 50.1587 56.7641 51.3339C55.4512 52.5526 53.6983 53.162 51.5056 53.162C50.3957 53.162 49.4211 53.013 48.5819 52.7151C47.7427 52.4172 47.0659 51.9433 46.5516 51.2933C46.0372 50.6433 45.7124 49.8105 45.577 48.7949C45.4417 47.7793 45.5229 46.5538 45.8207 45.1184L49.2722 28.9906C50.4092 28.7739 51.5056 28.4354 52.5613 27.975L52.805 26.7969ZM42.3288 26.7975H33.2736L33.0299 27.9756C33.4631 28.1923 33.9301 28.3819 34.4309 28.5444C34.9317 28.7069 35.4663 28.8558 36.0348 28.9912L27.4263 40.9347L23.325 28.9912C24.0289 28.8558 24.6515 28.6933 25.1929 28.5037C25.5539 28.3774 25.8907 28.257 26.2036 28.1426L26.6547 27.9756L26.8984 26.7975H16.1783L15.894 27.9756C16.3543 28.1923 16.8348 28.3886 17.3356 28.5647C17.8364 28.7407 18.3846 28.8829 18.9801 28.9912L24.2184 43.1691L22.1068 53.0814C20.8074 53.2439 19.6163 53.5689 18.5335 54.0563L18.3304 55.2345H28.6445L28.8475 54.0563C27.9541 53.5418 27.0067 53.2168 26.005 53.0814L28.1166 43.1284L38.7961 28.9912C39.3375 28.8829 39.8789 28.7543 40.4203 28.6053C40.9617 28.4563 41.5032 28.2465 42.0446 27.9756L42.3288 26.7975Z"
                fill="white"
            />
        </svg>
    );
};

export const Analytics = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
        >
            <rect width="2.90911" height="17.4547" rx="1.45456" fill="white" />
            <rect
                x="4.36377"
                y="7.27393"
                width="2.90911"
                height="10.1819"
                rx="1.45456"
                fill="white"
            />
            <rect
                x="8.72729"
                y="5.09229"
                width="2.90911"
                height="12.3637"
                rx="1.45456"
                fill="white"
            />
            <rect
                x="13.0908"
                y="12.3623"
                width="2.90911"
                height="5.09094"
                rx="1.45456"
                fill="white"
            />
        </svg>
    );
};

export const Buddies = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.97208 2.54945C7.23844 2.42623 7.54548 2.42623 7.81184 2.54945L15.1655 5.9515C15.5192 6.11514 15.7457 6.46936 15.7457 6.85908V10.6268C15.7457 11.053 15.4001 11.3986 14.9738 11.3986C14.5476 11.3986 14.202 11.053 14.202 10.6268V8.48385C14.202 7.7527 13.443 7.26873 12.7801 7.5772L7.81263 9.88881C7.54584 10.013 7.23792 10.0133 6.97085 9.88975L1.00005 7.12747C0.226547 6.76962 0.226547 5.67015 1.00005 5.3123L6.97208 2.54945ZM2.12549 10.5002C2.12549 9.76755 2.88741 9.28362 3.55059 9.59508L6.96684 11.1995C7.23614 11.326 7.54776 11.326 7.81705 11.1995L11.2333 9.59508C11.8965 9.28362 12.6584 9.76755 12.6584 10.5002V10.8757C12.6584 11.2656 12.4319 11.6198 12.078 11.7834L7.81158 13.7559C7.54536 13.8789 7.23853 13.8789 6.97231 13.7559L2.70585 11.7834C2.35201 11.6198 2.12549 11.2656 2.12549 10.8757V10.5002Z"
                fill="white"
            />
        </svg>
    );
};

export const Departments = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <rect width="7.2" height="7.2" rx="1.5" fill="#F3F5F5" />
            <rect y="8.7998" width="7.2" height="7.2" rx="1.5" fill="#F3F5F5" />
            <rect x="8.80005" width="7.2" height="7.2" rx="1.5" fill="#F3F5F5" />
            <rect x="9.30005" y="9.2998" width="6.2" height="6.2" rx="1" stroke="#F3F5F5" />
        </svg>
    );
};

export const Unibuddy = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="177"
            height="48"
            viewBox="0 0 177 48"
            fill="none"
        >
            <path
                d="M58.5254 24.6307V19.1096C58.5254 18.6814 58.7599 18.4561 59.2054 18.4561H60.2136C60.6357 18.4561 60.8702 18.6814 60.8702 19.1096V24.7208C60.8702 26.3659 61.9722 27.4927 63.6135 27.4927C65.2549 27.4927 66.3569 26.3659 66.3569 24.7208V19.1096C66.3569 18.6814 66.5914 18.4561 67.0369 18.4561H67.9748C68.3969 18.4561 68.6548 18.6814 68.6548 19.1096V24.6307C68.6548 27.5603 66.6383 29.4983 63.637 29.4983C60.5653 29.5208 58.5254 27.5603 58.5254 24.6307ZM83.8958 19.1997V28.8223C83.8958 29.318 83.5441 29.5208 83.122 29.5208H82.9813C82.5827 29.5208 82.3013 29.2955 81.9731 28.9124L76.416 22.4899V28.7772C76.416 29.2053 76.1815 29.4532 75.7594 29.4532H74.7746C74.3526 29.4532 74.0946 29.2053 74.0946 28.7772V19.1546C74.0946 18.6589 74.4464 18.4561 74.8684 18.4561H75.0091C75.4077 18.4561 75.6891 18.6814 76.0174 19.0645L81.5745 25.487V19.1997C81.5745 18.7715 81.8089 18.5462 82.231 18.5462H83.2158C83.6613 18.5462 83.8958 18.7715 83.8958 19.1997ZM89.5232 28.8223V19.1096C89.5232 18.6814 89.7577 18.4561 90.2032 18.4561H91.2115C91.657 18.4561 91.868 18.7039 91.868 19.1096V28.8223C91.868 29.2504 91.6335 29.4983 91.2115 29.4983H90.2032C89.7811 29.5208 89.5232 29.2504 89.5232 28.8223ZM105.819 26.4561C105.819 28.3039 104.155 29.5208 101.646 29.5208H97.9409C97.6127 29.5208 97.4251 29.318 97.4251 29.0025V18.9744C97.4251 18.6589 97.6127 18.4561 97.9409 18.4561H101.341C103.826 18.4561 105.163 19.4701 105.163 21.4082C105.163 22.5124 104.506 23.2561 103.686 23.7068C104.975 24.1124 105.819 25.1039 105.819 26.4561ZM98.8554 19.6279V23.2786H101.458C102.935 23.2786 103.756 22.6251 103.756 21.4532C103.756 20.2363 102.959 19.6054 101.458 19.6054H98.8554V19.6279ZM104.389 26.3434C104.389 25.149 103.404 24.3603 101.927 24.3603H98.8554V28.3265H101.599C103.428 28.3265 104.389 27.6504 104.389 26.3434ZM110.532 24.9913V18.9518C110.532 18.6363 110.696 18.4561 111.025 18.4561H111.447C111.752 18.4561 111.939 18.6363 111.939 18.9518V24.9913C111.939 26.9518 113.276 28.2814 115.269 28.2814C117.285 28.2814 118.598 26.9518 118.598 24.9913V18.9518C118.598 18.6363 118.762 18.4561 119.091 18.4561H119.513C119.818 18.4561 119.982 18.6363 119.982 18.9518V24.9913C119.982 27.6955 118.106 29.4983 115.292 29.4983C112.432 29.5208 110.532 27.6955 110.532 24.9913ZM125.328 29.0025V18.9744C125.328 18.6589 125.515 18.4561 125.844 18.4561H129.736C133.3 18.4561 135.645 20.6645 135.645 23.9772C135.645 27.3124 133.3 29.5208 129.736 29.5208H125.844C125.515 29.5208 125.328 29.2955 125.328 29.0025ZM129.736 28.3039C132.479 28.3039 134.238 26.5913 134.238 23.9772C134.238 21.3631 132.479 19.6504 129.736 19.6504H126.758V28.2814H129.736V28.3039ZM140.709 29.0025V19.2223C140.709 18.9068 140.897 18.7265 141.225 18.7265H145.024C148.494 18.7265 150.792 20.8899 150.792 24.0899C150.792 27.3349 148.494 29.4983 145.024 29.4983H141.225C140.897 29.5208 140.709 29.318 140.709 29.0025ZM145 28.3265C147.673 28.3265 149.385 26.6589 149.385 24.1124C149.385 21.5659 147.65 19.8983 145 19.8983H142.093V28.3265H145ZM163.923 18.9068L159.726 25.3068V29.0025C159.726 29.318 159.561 29.5208 159.233 29.5208H158.788C158.483 29.5208 158.295 29.318 158.295 29.0025V25.3518L154.051 18.9068C153.887 18.6814 154.051 18.4561 154.356 18.4561H154.942C155.247 18.4561 155.435 18.6138 155.622 18.9293L159.022 24.1575L162.399 18.9293C162.586 18.6138 162.774 18.4561 163.079 18.4561H163.618C163.899 18.4561 164.063 18.6814 163.923 18.9068Z"
                fill="white"
            />
            <path
                d="M28.4889 10.2764V23.7524L35.2184 23.189C35.617 27.4707 32.6861 31.2792 28.4889 32.2707V37.6566C36.3673 37.6566 42.7451 31.5271 42.7451 23.9552V10.2764H28.4889ZM33.835 20.5299C32.8502 20.5299 32.053 19.7637 32.053 18.8172C32.053 17.8707 32.8502 17.1045 33.835 17.1045C34.8198 17.1045 35.617 17.8707 35.617 18.8172C35.617 19.7637 34.8198 20.5299 33.835 20.5299ZM17.4216 24.6764L24.9483 24.0454V10.2764H10.6921V23.9778C10.6921 31.5496 17.0699 37.6792 24.9483 37.6792V32.451C20.9622 31.82 17.7733 28.7102 17.4216 24.6764ZM19.6023 17.1045C20.5871 17.1045 21.3843 17.8707 21.3843 18.8172C21.3843 19.7637 20.5871 20.5299 19.6023 20.5299C18.6175 20.5299 17.8202 19.7637 17.8202 18.8172C17.8202 17.8707 18.6175 17.1045 19.6023 17.1045Z"
                fill="#01D4CF"
            />
        </svg>
    );
};

export const UnibuddyLogoOnly = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 60 60"
            fill="none"
        >
            <path
                d="M28.4889 10.2764V23.7524L35.2184 23.189C35.617 27.4707 32.6861 31.2792 28.4889 32.2707V37.6566C36.3673 37.6566 42.7451 31.5271 42.7451 23.9552V10.2764H28.4889ZM33.835 20.5299C32.8502 20.5299 32.053 19.7637 32.053 18.8172C32.053 17.8707 32.8502 17.1045 33.835 17.1045C34.8198 17.1045 35.617 17.8707 35.617 18.8172C35.617 19.7637 34.8198 20.5299 33.835 20.5299ZM17.4216 24.6764L24.9483 24.0454V10.2764H10.6921V23.9778C10.6921 31.5496 17.0699 37.6792 24.9483 37.6792V32.451C20.9622 31.82 17.7733 28.7102 17.4216 24.6764ZM19.6023 17.1045C20.5871 17.1045 21.3843 17.8707 21.3843 18.8172C21.3843 19.7637 20.5871 20.5299 19.6023 20.5299C18.6175 20.5299 17.8202 19.7637 17.8202 18.8172C17.8202 17.8707 18.6175 17.1045 19.6023 17.1045Z"
                fill="#01D4CF"
            />
        </svg>
    );
};

export const Chevron = ({className}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            className={className}
        >
            <path
                d="M1 1L5 5L9 1"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
